/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Group15IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Group15Icon(props: Group15IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 27 31"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M22.969 0H.656A.656.656 0 0 0 0 .656v25.266a2.953 2.953 0 0 0 5.906 0v-1.64h17.719V.655A.656.656 0 0 0 22.969 0m-5.25 18.375H5.906a.656.656 0 0 1 0-1.313H17.72a.656.656 0 0 1 0 1.313zm0-5.25H5.906a.656.656 0 0 1 0-1.313H17.72a.656.656 0 0 1 0 1.313zm0-5.25H5.906a.656.656 0 0 1 0-1.313H17.72a.656.656 0 0 1 0 1.313z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M7.219 25.594v.328c0 2.352-1.586 4.265-3.938 4.265h20.344a3.28 3.28 0 0 0 3.281-3.28v-1.313z"
        }
      ></path>
    </svg>
  );
}

export default Group15Icon;
/* prettier-ignore-end */
